import { Injectable } from '@angular/core';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CartType, OrderEntry, ReelCutting, ReelCuttingOptions, ReelCuttingRequest } from '../../../../core/model';
import { CART_CORE_FEATURE } from '../store/cart-state';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: ReelCuttingFacade,
      feature: CART_CORE_FEATURE,
      async: true,
      methods: ['getOptions', 'calculatePrice', 'calculatePriceLoading', 'calculatePriceLoaded'],
    }),
})
export abstract class ReelCuttingFacade {
  abstract getOptions(entry: OrderEntry, cartType: CartType): Observable<ReelCuttingOptions>;
  abstract calculatePrice(
    entry: OrderEntry,
    request: ReelCuttingRequest,
    cartType: CartType
  ): Observable<ReelCutting | undefined>;
  abstract calculatePriceLoading(entry: OrderEntry, request: ReelCuttingRequest, cartType: CartType): Observable<boolean>;
  abstract calculatePriceLoaded(entry: OrderEntry, request: ReelCuttingRequest, cartType: CartType): Observable<boolean>;
}
